var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.45,
    height: 21.475,
    viewBox: "0 0 22.45 21.475",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1007.58 -133.262)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 18.916,
    y2: 17.941,
    transform: "translate(-1005.813 135.03)",
    fill: "none",
    stroke: "#112c5a",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.916,
    y2: 17.941,
    transform: "translate(-1005.813 135.03)",
    fill: "none",
    stroke: "#112c5a",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e8e96d157df59359bfb953feec9c6671.svg";
export { ForwardRef as ReactComponent };